import Permissions from '../../models/Permissions'
const Register = () => import(/* webpackChunkName: "adduser" */ './Register.vue')

const permissions = [
  Permissions.ROOT,
  Permissions.ADMINISTRADOR
]

// const register = {
//   path: 'register',
//   name: 'Registro',
//   component: Register,
//   meta: {
//     requiresLogin: false,
//     permissions: []
//   }
// }

const create = {
  path: 'adduser',
  name: 'Cadastro',
  component: Register,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

export default {
  // register,
  create
}



// WEBPACK FOOTER //
// ./src/views/register/index.js